export default __webpack_public_path__ + "static/media/call-calling.de33375e.svg";